import './S_ColorPicker.scss';
import 'react-color-palette/dist/css/rcp.css';
import { observer } from 'mobx-react-lite';
import { ReactElement, useEffect, useRef, useState } from 'react';
import { ColorPicker, IColor, useColor } from 'react-color-palette';
import { getContrastingColor } from '../../../__legacy__/helpers/color.helpers';
import { S_TextInput } from '../../inputs/textInput/S_TextInput';

export interface S_ColorPickerProps {
  value: string;
  onChange(value: string): void;
  disabled?: boolean;
  id?: string;
}

export const S_ColorPicker = observer((props: S_ColorPickerProps): ReactElement => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [color, setColor] = useColor(props.value);
  const menuRef = useRef<HTMLDivElement>(null);

  const autoClose = (evt: Event): void => {
    if (!menuRef.current || menuRef.current.contains(evt.target as Node)) {
      return;
    }
    setIsOpen(false);
  };

  useEffect(() => {
    const parent = menuRef.current?.closest('.s-modal');
    if (isOpen) {
      parent?.addEventListener('click', autoClose);
    } else {
      parent?.removeEventListener('click', autoClose);
    }
    return (): void => parent?.removeEventListener('click', autoClose);
  }, [isOpen]);

  const handleChange = (color: IColor): void => {
    props.onChange(color.hex);
    setColor(color);
  };

  return (
    <div
      className='s-color-picker'
      ref={menuRef}
    >
      {isOpen && (
        <ColorPicker
          color={color}
          onChange={handleChange}
          hideAlpha
        />
      )}
      <S_TextInput
        id={props.id}
        value={props.value}
        className='rc-color-picker-trigger'
        readOnly={true}
        css={{ '--background-color': props.value, '--text-color': getContrastingColor(props.value) }}
        disabled={props.disabled}
        onClick={(): void => {
          setIsOpen((isOpen) => !isOpen);
        }}
      />
    </div>
  );
});
